// Trigger Webpack rebuild
import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS,
} from '../../themes'
import { colorThemeSelector } from '../../helpers/functions/themes'

const Style = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: stretch;
  align-items: center;
  padding: 0;
  margin: 0;

  .input-box {
    position: relative;
    flex: 3;
    border-radius: 8px;
    border: 1.5px solid ${COLOR.GRAY_5};
    background-color: white;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    margin: 0;
    min-height: 48px;
    box-sizing: border-box;
    cursor: pointer;
  }
  
  .dropdown-container {
    box-shadow: none;
    position: absolute;
    top: calc(100% + 8px);
    left: -1.5px;
    background-color: white;
    max-height: 0px;
    border-radius: 8px;
    border: 1.5px solid transparent;
    width: calc(100% + 3px);
    height: auto;
    display: flex;
    flex-flow: column nowrap;
    overflow-y: scroll;
    justify-content: flex-start;
    align-items: stretch;
    z-index: ${Z_INDEXS.LV_9};
    transition: max-height 100ms ease-in, opacity 60ms ease-in, border-color 60ms ease-in;
    margin: 0;
    padding: 0;
    opacity: 0;
    outline: none;
    pointer-events: none;
  }
  
  .dropdown-container.is-showing {
    max-height: 300px;
    transition: max-height 100ms ease-out, opacity 60ms ease-in, border-color 60ms ease-in;
    opacity: 1;
    border-color: ${COLOR.GRAY_5};
    pointer-events: auto;
  }
  
  .dropdown-container button {
    font-size: 18px;
    font-family: 'NunitoRegular', sans-serif;
    color: ${COLOR.BLACK_6};
    flex: 1;
    padding: 8px 16px;
    margin: 0;
    background-color: transparent;
    border: none;
    outline: none;
    line-height: 1.5;
    min-height: auto;
    height: auto;
    text-align: left;
    display: flex;
    align-items: center;
  }
  
  .dropdown-container button:hover,
  .dropdown-container button:focus {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
    cursor: pointer;
  }
  
  .dropdown-container button:active {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: white;
  }
  
  .button-container {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 20px;
    padding: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .button-container > svg,
  .button-container > img {
    cursor: pointer;
    width: 20px !important;
    height: 20px !important;
  }
  
  .input-box > label {
    font-size: 18px !important;
    font-family: 'NunitoRegular', sans-serif;
    color: ${COLOR.BLACK_6};
    flex: 1;
    padding: 0;
    margin: 0;
    text-align: left;
    cursor: pointer;
  }

  
  .disabled,
  .disabled * {
    background-color: #F1F2F2 !important;
    cursor: not-allowed !important;
    color: #A0A0A0 !important;
  }
  
  .label-text {
    margin-left: 12px;
    text-align: left;
  }
`

export default Style


